import spacing from './spacing.module.scss';
import lineWidths from './line-widths.module.scss';
import colors from './colors.module.scss';

export const Spacing = spacing;
export const LineWidths = lineWidths;
export const Colors = colors;
